import { cn } from '@/lib/utils';

export default function Title({
  text,
  colorClass = 'text-heineken-green',
  isSmall = false,
  className = '',
}: {
  text: string;
  colorClass?: string;
  isSmall?: boolean;
  className?: string;
}) {
  return (
    <p
      className={cn(
        'text-3xl md:text-5xl font-bold  font-heineken mb-6 ',
        colorClass,
        isSmall && 'text-3xl',
        className
      )}
    >
      {text}
    </p>
  );
}
